export default __webpack_public_path__ + "static/media/ajw-logo-light.b74bc206.svg";